import { gql, useFragment } from "@apollo/client";

// Styling
import style from "./menu-wp.module.scss";

// Components
import Link from "next/link";
import IconFA from "@/components/icon-fa/icon-fa";
import Btn from "@/components/btn/btn";

export default function MenuWP({ menu, caratShow = false, navStyle = "" }) {
  // Use Fragment
  const { complete, data } = useFragment({
    fragment: MenuWP.fragments.menu,
    fragmentName: "WpMenuFragment",
    from: menu,
  });
  if (!complete) {
    return;
  }

  // Define Variables
  const menuSlug = data.slug;
  const menuItems = data.menuItems.nodes;
  var menuLayout = {};

  // Function - Change Flat Menu Items Query to Hierarchical List
  const flatListToHierarchical = (
    data = [],
    { idKey = "id", parentKey = "parentId", childrenKey = "children" } = {}
  ) => {
    const tree = [];
    const childrenOf = {};
    data.forEach((item) => {
      const newItem = { ...item };
      const { [idKey]: id, [parentKey]: parentId = 0 } = newItem;
      childrenOf[id] = childrenOf[id] || [];
      newItem[childrenKey] = childrenOf[id];
      parentId
        ? (childrenOf[parentId] = childrenOf[parentId] || []).push(newItem)
        : tree.push(newItem);
    });
    return tree;
  };
  menuLayout = flatListToHierarchical(menuItems);

  // Function - Generate Menu Item (Recursive)
  const wpMenuItemGeneration = (data = [], index = 0, depth = 0) => {
    depth++;
    return (
      <li id={`menu-item-` + data.id} className="menu-item" key={index}>
        {data.uri === "#" ? (
          <span>{data.label}</span>
        ) : (
          // <Link href={data.uri}>{data.label}</Link>
          <Btn button={{ url: data.uri, title: data.label }} />
        )}
        {!!data.children.length && caratShow && depth === 1 && (
          <button className={`menuButton hidden`}>
            <IconFA name="faChevronDown" color="var(--color--font)" />
          </button>
        )}
        {!!data.children.length && (
          <ul
            className="submenu"
            depth={depth}
            state={depth === 1 ? "closed" : {}}
          >
            {data.children.map((item, index) => {
              const menuItem = wpMenuItemGeneration(item, index, depth);
              return menuItem;
            })}
          </ul>
        )}
      </li>
    );
  };

  return (
    <nav
      wp_menu={menuSlug}
      className={`wp-menu ${style.navGeneral} ${style[navStyle]}`}
      aria-label="Main Navigation"
    >
      <ul className="menu" depth="0">
        {/* {menuLayout.map((item, index) => {
          const menuItem = wpMenuItemGeneration(item, index);
          return menuItem;
        })} */}

        <li id={`menu-item-` + data.id} className="menu-item">
          <Btn button={{ url: "/glossary/", title: "Glossary" }} />
        </li>
        <li id={`menu-item-` + data.id} className="menu-item">
          <Btn button={{ url: "/faqs/", title: "FAQs" }} />
        </li>
        <li id={`menu-item-` + data.id} className="menu-item">
          <Btn button={{ url: "/ingredients/", title: "Browse Ingredients" }} />
        </li>
      </ul>
    </nav>
  );
}

MenuWP.fragments = {
  menu: gql`
    fragment WpMenuFragment on Menu {
      id
      slug
      menuItems {
        nodes {
          id
          uri
          path
          label
          parentId
        }
      }
    }
  `,
};
